{
  "endTime": "Χρόνος λήξης",
  "startTime": "Ώρα έναρξης",
  "time": "Χρόνος"
}
